/**
 * @description 一个固定的ratio值
 */
export const $ratio = 750/640
/**
 * @description 一个固定的默认字体大小
 */
export const $browserDefaultFontSize = 14

/** 健康险静态资源空间地址 */
export const HEALTH_INSURANCE_STATIC_DOMAIN = 'https://cdn-health.zhongan.com/hic/library/resource/69c20747a2f5c8001dbfa793';